import { BackgroundCheckTypes, RosterParticipant } from '../../../models';

export interface ParticipantBackgroundCheckWaivedOption {
  visible: boolean;
  disabled: boolean;
}

/** Whether the admin panel should show the Waived radio, and whether it is selectable. */
export function participantBackgroundCheckWaivedOption(
  participant: RosterParticipant,
): ParticipantBackgroundCheckWaivedOption {
  const backgroundCheck = participant.backgroundCheck;
  if (!backgroundCheck) {
    return { visible: false, disabled: false };
  }

  const alreadyWaived =
    participant.newtripUser.backgroundCheckType === BackgroundCheckTypes.Waived;

  if (backgroundCheck.waivable) {
    return { visible: true, disabled: false };
  }

  if (alreadyWaived) {
    return { visible: true, disabled: true };
  }

  return { visible: false, disabled: false };
}
